/*eslint-env node*/
// @ts-nocheck
var auth = {
  getTokenISAM: window._env_.REACT_APP_ENDPOINT_OAUTH_ISAM + '/mga/sps/oauth/oauth20/',
  logoutISAM: window._env_.REACT_APP_ENDPOINT_OAUTH_ISAM + '/pkmslogout',
  refreshTokenISAM: window._env_.REACT_APP_ENDPOINT_OAUTH_ISAM + '/mga/sps/oauth/oauth20/token',
  getTokenC_ID: window._env_.REACT_APP_ENDPOINT_OAUTH_C_ID + '/myidentity/notifier/signinorsignup',
  logoutC_ID: window._env_.REACT_APP_ENDPOINT_OAUTH_C_ID + '/myidentity/notifier/singout',
  refreshTokenC_ID: window._env_.REACT_APP_ENDPOINT_OAUTH_C_ID + '/myidentity/notifier/RefreshToken',
  userDataC_ID: window._env_.REACT_APP_ENDPOINT_OAUTH_API_C_ID + '/api/Accounts/user'
};
export { auth };